// src/components/SiteHeader.js
import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared top nav for pages that otherwise have no way back to the rest of
 * the site (currently: the blog). Mirrors the nav-banner pattern already
 * hand-rolled independently in Home.js/CategoriesPage.js/ThemeLandingPage.js,
 * plus a link to /events, which none of those need (they already are the
 * main entry points) but blog readers do.
 */
const SiteHeader = () => {
  const isLoggedIn = !!localStorage.getItem("memberstackToken");

  return (
    <section
      className="nav-banner"
      style={{
        background: "linear-gradient(135deg, #FBFAFF, #F5F2FF)",
        borderBottom: "1px solid rgba(139, 95, 191, 0.08)",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <div className="padding-global">
        <div className="container-large">
          <div
            className="nav-content"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 0",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <Link to="/" style={{ textDecoration: "none" }}>
              <span
                className="nav-logo"
                style={{
                  fontSize: "2rem",
                  fontWeight: "800",
                  background: "linear-gradient(135deg, #8B5FBF, #6B46C1)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  margin: 0,
                  lineHeight: "44px",
                  display: "inline-block",
                }}
              >
                OkGather
              </span>
            </Link>

            <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
              <Link
                to="/events"
                style={{
                  color: "#6B46C1",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                }}
              >
                Events
              </Link>
              <Link
                to="/blog"
                style={{
                  color: "#6B46C1",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                }}
              >
                Blog
              </Link>
              {isLoggedIn ? (
                <Link
                  to="/edit-profile"
                  style={{
                    background: "transparent",
                    color: "#8B5FBF",
                    padding: "10px 22px",
                    borderRadius: "25px",
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    border: "2px solid #8B5FBF",
                  }}
                >
                  My Profile
                </Link>
              ) : (
                <Link
                  to="/events"
                  style={{
                    background: "linear-gradient(135deg, #8B5FBF, #2c2e96)",
                    color: "#fff",
                    padding: "10px 22px",
                    borderRadius: "25px",
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    fontWeight: "600",
                    boxShadow: "0 2px 10px rgba(139, 95, 191, 0.2)",
                  }}
                >
                  Join Us
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SiteHeader;
